export { version } from './src/package.js'
import { template } from './src/template.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery.fn, {
    template: template
  })
}
